
























import { Component, Prop, Vue } from 'vue-property-decorator'
import { nl2br } from '@/utils/string'

@Component
export default class NoticeModal extends Vue {
  @Prop(String) message!: string
  @Prop({ type: Number, default: 166 }) height!: number

  nl2br = nl2br

  handleClickClose() {
    this.$emit('close')
  }
}
